<form [formGroup]="formData">
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label for="">Client Id</label>
        <input type="text" class="text lum-input" formControlName="client_id" />
      </div>
      <div class="form-group">
        <label for="">Client Secret</label>
        <input type="text" class="text lum-input" formControlName="client_id" />
      </div>
    </div>
  </div>
</form>
